<div class="footer">
    <button
        class="button-no-border footer__item"
        aria-label="Open company page"
        mat-flat-button
        [addIntercomDataAttribute]="{key: 'nav-company-btn', isMobile: true, isDesktop: false}"
        data-ga-value="nav-mobile-company"
        (click)="navigateTo(['/company'])"
        [myRouterLinkActive]="'/company'">
        <div class="footer__item-label">
            <i class="icon icon-company"></i>
            <span>{{ 'LABELS.COMPANY' | translate }}</span>
        </div>
    </button>
    <button
        aria-label="Open orders page"
        class="button-no-border footer__item"
        mat-flat-button
        data-ga-value="nav-mobile-orders"
        (click)="navigateTo(['/orders'])"
        [myRouterLinkActive]="['/orders/list', '/orders/planning']">
        <div class="footer__item-label">
            <i class="icon icon-order"></i>
            <div>{{ 'LABELS.OVERVIEW' | translate }}</div>
        </div>
    </button>
    <ng-container *showWhenRight="'CREATE_ORDER_REORDER'">
        <button
            aria-label="Create new order"
            *ngIf="allowedToOrder$ | async"
            class="primary button-no-border footer__item footer__item-action"
            mat-flat-button
            data-ga-value="nav-mobile-new-order"
            [addIntercomDataAttribute]="{key: 'nav-new-order-btn', isMobile: true, isDesktop: false}"
            (click)="navigateTo(['/orders/add'])">
            <div class="footer__item-label">
                <div><i class="icon icon-plus"></i></div>
                <div class="word-wrap"><span>{{ 'LABELS.NEW_ORDER' | translate }}</span></div>
            </div>
        </button>
    </ng-container>
    <ng-container *showWhenRight="'VIEW_INVOICES'">
        <button
            class="button-no-border footer__item"
            aria-label="Open invoices page"
            mat-flat-button
            [addIntercomDataAttribute]="{key: 'nav-invoices-btn', isMobile: true, isDesktop: false}"
            data-ga-value="nav-mobile-invoices"
            (click)="navigateTo(['/invoices'])"
            [myRouterLinkActive]="'/invoices'">
            <div class="footer__item-label">
                <i class="icon icon-payment"></i>
                <span>{{ 'LABELS.INVOICES' | translate }}</span>
            </div>
        </button>
    </ng-container>
    <button
        class="button-no-border footer__item"
        aria-label="Open contact page"
        mat-flat-button
        [addIntercomDataAttribute]="{key: 'nav-contact-btn', isMobile: true, isDesktop: false}"
        data-ga-value="nav-mobile-contact"
        (click)="navigateTo(['/contact'])"
        [myRouterLinkActive]="'/contact'">
        <div class="footer__item-label">
            <i class="icon icon-support"></i>
            <span>{{ 'LABELS.CONTACT' | translate }}</span>
        </div>
    </button>
</div>
